<template>
  <el-dialog title="更换设备"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-form :model="modalInfo"
               :rules="modalRules"
               ref="modalForm"
               label-width="100px"
               class="modal-form">
        <el-form-item label="更换为："
                      prop="newId">
          <el-select v-model="modalInfo.newId"
                     placeholder="请选择新设备">
            <el-option v-for="item in gateList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/lock/replace'"
                 type="primary"
                 @click="handleConfirm('modalForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      modalInfo: {
        newId: ''
      },
      modalRules: {
        newId: [{ required: true, message: '请选择要更换的新设备' }]
      },
      gateList: []
    }
  },
  created() {
    this.getLockList()
  },
  methods: {
    // 获取新设备
    getLockList() {
      fetch.getLockList({ type: 'new', perPage: 0, currentPage: 0 }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.gateList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.changeLock({ ...this.modalInfo, oldId: this.data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.handleCancel()
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style></style>
